module.exports = __webpack_public_path__ + "static/img/fun3.9c738eb3.png";